// extracted by mini-css-extract-plugin
export default {"collegesContainer":"AffiliatedColleges_collegesContainer__f4t4-","collegeTable":"AffiliatedColleges_collegeTable__Qlpqy"};